import React, { useContext } from 'react';
import { Typography, Grid, Paper } from '@material-ui/core';
import PhoneIcon from '@material-ui/icons/Phone';
import { I18nContext } from 'translations';

export default function CustomerBlock({
  customer,
  labelKey = 'app.deliveryRoute.customerLabel',
  captionKey = 'app.deliveryRoute.receivesPackage',
  testId = 'customer-block',
}) {
  const { translate } = useContext(I18nContext);
  if (!customer || (!customer.name && !customer.phone)) return null;

  return (
    <Paper
      elevation={0}
      data-testid={testId}
      style={{ backgroundColor: '#FAF8FB', border: '1px solid #F2EFF5', borderRadius: 8, padding: 12, marginTop: 12 }}
    >
      <Grid container justify="space-between" alignItems="center">
        <Grid item>
          <Typography variant="caption" color="textSecondary" style={{ textTransform: 'uppercase', letterSpacing: 0.3 }}>
            {translate(labelKey)}
          </Typography>
          <Typography variant="body2" color="textPrimary" style={{ fontWeight: 700 }}>
            {customer.name || '-'}
          </Typography>
          <Typography variant="caption" color="textSecondary">
            {translate(captionKey)}
          </Typography>
        </Grid>
        {customer.phone && (
          <Grid item>
            <a
              href={`tel:${customer.country_code || ''}${customer.phone}`}
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: 6,
                backgroundColor: '#EFE3FB',
                color: '#7825bd',
                fontWeight: 700,
                textDecoration: 'none',
                borderRadius: 20,
                padding: '8px 14px',
                fontSize: 13,
              }}
            >
              <PhoneIcon style={{ fontSize: 16 }} />
              {customer.country_code} {customer.phone}
            </a>
          </Grid>
        )}
      </Grid>
    </Paper>
  );
}
